import { ArrowDropDown, Info as Info$1 } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Status } from "../../todo-list.types.js";
const StatusBox = styled("div", {
  shouldForwardProp: (props) => props !== "margin" && props !== "readonly"
})(({ theme, state, readonly }) => ({
  display: "flex",
  padding: "4px 4px 4px 8px",
  justifyContent: "center",
  alignItems: "center",
  gap: "4px",
  borderRadius: "4px",
  backgroundColor: theme.palette.warning[100],
  cursor: "pointer",
  ...state === Status.DONE && {
    backgroundColor: theme.palette.success[100]
  },
  ...state === Status.IGNORED && {
    backgroundColor: theme.palette.grey[200]
  },
  ...state === Status.RECALLED && {
    backgroundColor: theme.palette.secondary[50],
    // orange mapped to secondary
    color: theme.palette.secondary[900]
  },
  ...readonly && {
    cursor: "default",
    padding: "4px 8px"
  }
}));
const Container = styled("div")`
  display: flex;
  gap: 4px;
  align-items: center;
`;
const ArrowDownIcon = styled(ArrowDropDown)`
  width: 16px;
  height: 16px;
`;
const Text = styled(Typography, {
  shouldForwardProp: (props) => props !== "margin"
})(({ theme, state }) => ({
  color: theme.palette.grey[900],
  textAlign: "center",
  fontSize: "12px",
  fontWeight: 700,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  textTransform: "uppercase",
  ...state === Status.TO_DO && {
    color: theme.palette.grey[900]
  },
  ...state === Status.DONE && {
    color: theme.palette.success[900]
  },
  ...state !== Status.IGNORED && {
    color: theme.palette.grey[800]
  },
  ...state === Status.RECALLED && {
    color: theme.palette.secondary[900]
    // orange mapped to secondary
  }
}));
const Info = styled(Info$1)(({ theme }) => ({
  color: theme.palette.grey[500],
  width: "20px",
  height: "20px"
}));
export {
  ArrowDownIcon,
  Container,
  Info,
  StatusBox,
  Text
};
